export default __webpack_public_path__ + "static/media/redShed.30e09fe6.png";